// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

import styles from './TabsVertical.module.scss';;


type Props = {
  children: Node,
  className?: string,
}

const TabsVertical = ({ children, className }: Props) => (
  <div className={classNames(styles.root, className)}>
    {children}
  </div>
);

export default TabsVertical;
